import ValidationResult from "domain/types/global/validationResult"

export const CAMPANHA_RESGATE_APROVAR = 'CAMPANHA_RESGATE_APROVAR'
export const CAMPANHA_RESGATE_REPROVAR = 'CAMPANHA_RESGATE_REPROVAR'

export interface AprovarPedidoState {
	mudancaStatus: ValidationResult;
}

export interface AprovarResgateAction {
	type: typeof CAMPANHA_RESGATE_APROVAR,
	payload: ValidationResult
}

export interface ReprovarResgateAction {
	type: typeof CAMPANHA_RESGATE_REPROVAR,
	payload: ValidationResult
}

export type AprovarPedidoActionTypes =
	AprovarResgateAction |
	ReprovarResgateAction